import React, { useEffect, useState } from 'react'
import {
    Flex,
   
    Box,
    Image,
    Button,
    chakra,
    Tooltip,
  } from '@chakra-ui/react';
  import "../CSS/Product.css"
import { useDispatch, useSelector } from 'react-redux';
import { getWishlist } from '../Redux/action';

function WishList() {

    const {wishlist} = useSelector(e => e.product)
    const {token} = useSelector(e => e.auth)
    const dispatch = useDispatch()

    useEffect(()=>{
      dispatch(getWishlist(token))
    },[])
if(wishlist?.length===0)return <h1  style={{fontSize:"50px"}}>Nothing in Wishlist!!</h1>

   if(wishlist){ return (
        <div className='Product'>
        {wishlist?.map((el)=>(
            <div key={el.id}>
                <Box
          maxW="xs"
          borderWidth="1px"
          rounded="lg"
          shadow="lg"
         >
          
  
          <Image
          w="100%"
            src={el.image}
            alt={`Picture of ${el.Title}`}
            roundedTop="lg"
          />
  
          <Box p="6">
            <Box d="flex" alignItems="baseline">
             
            </Box>
            <Flex mt="1" justifyContent="space-between" alignContent="center">
              <Box
                fontSize="2xl"
                fontWeight="semibold"
                as="h4"
                lineHeight="tight"
                isTruncated>
                {el.Title}
              </Box>
              
              <Tooltip
                label="Add to cart"
                bg="white"
                placement={'top'}
                color={'gray.800'}
                fontSize={'1.2em'}>
                <chakra.a href={'#'} display={'flex'}>
                </chakra.a>
              </Tooltip>
            </Flex>
            <Box
                fontSize="2xl"
                // fontWeight="semibold"
                
                lineHeight="tight"
                isTruncated>
               <p>{el.category}</p> 
              </Box>
            <Flex justifyContent="center" alignContent="center">
              <Box fontSize="2xl" >
                <Box as="span" color={'black.600'} fontSize="lg" textAlign="center">
                  ₹ {el.Price}
                </Box>
              
              </Box>
            </Flex>
            <Button colorScheme="red" >Remove</Button>
            <Button ml='2'>Add to Cart</Button>
          </Box>
        </Box>
            </div>
        ))}
        </div>
    )}else{
        return <h1  style={{fontSize:"50px"}}>Nothing in Wishlist!!</h1>
    }
}

export default WishList
